import _ from 'lodash';
import { groupBy } from '../utils/collection';
import { types } from '../constants/filter';
import { binarySearch, getRange, toCohortFormat, unwrapRows } from '../utils/chart/converter';

const createEmptyRows = (info, firstRow, dates) => {
  const rows = [];

  for (let i = 0; i < dates.length; i++) {
    const data = { ...firstRow, [info.groupBy]: dates[i].valueOf(), [info.aggregation[0]]: 0 };

    rows.push({
      data,
    });
  }

  return rows;
};

const groupBySplitWithDates = (data, info) => {
  const dates = getRange(info);
  const groups = {};

  for (let i = 0; i < data.length; i++) {
    const groupName = data[i][info.splitBy];

    if (groups[groupName] === undefined) {
      groups[groupName] = createEmptyRows(info, data[i], dates);
    }

    const row = binarySearch(
      groups[groupName],
      (r) => data[i][info.groupBy] - r.data[info.groupBy]
    );
    row.data = data[i];
  }

  const groupEntries = Object.entries(groups);
  const result = {};

  for (let i = 0; i < groupEntries.length; i++) {
    result[groupEntries[i][0]] = unwrapRows(groupEntries[i][1]);
  }

  return result;
};

const getCategories = (rows, field) => {
  const categories = {};

  for (let i = 0; i < rows.length; i++) {
    categories[rows[i][field]] = null;
  }

  return categories;
};

const getSeriesData = (rows, info) => {
  const data = [];

  for (let i = 0; i < rows.length; i++) {
    data.push([
      rows[i][info.groupBy],
      // проверка сделана для того чтобы исключить из значений агрегаций null
      rows[i][info.aggregation[0]] ? rows[i][info.aggregation[0]] : 0,
    ]);
  }

  return data;
};

const isDateField = (field = '') => {
  const isDate = field.includes(types.COHORT) || field === 'permanent.register_date';
  return isDate;
};

const convertEventData = ({ info, result }) => {
  let groupsBySplits;
  let categories = {};
  let isCohort = false;

  if (info.timeUnit !== undefined) {
    groupsBySplits = Object.entries(groupBySplitWithDates(result.rows, info));
    categories = _.get(groupsBySplits, '[0][1]', []).map((v) => v[info.groupBy]);
  } else {
    categories = Object.keys(getCategories(result.rows, info.groupBy));
    groupsBySplits = Object.entries(groupBy(result.rows, (row) => row[info.splitBy]));

    isCohort = isDateField(info.groupBy);
    categories = isCohort
      ? categories.map((category) => toCohortFormat(category, info.timezone))
      : categories;
  }

  const isSplitCohort = isDateField(info.splitBy);
  const groups = [];

  for (let i = 0; i < groupsBySplits.length; i++) {
    const rows = groupsBySplits[i][1];
    const data = getSeriesData(rows, info);
    const dataSum = data.reduce((sum, dataItem) => sum + dataItem[1], 0);

    groups.push({
      name: isSplitCohort
        ? toCohortFormat(groupsBySplits[i][0], info.timezone)
        : groupsBySplits[i][0],
      id: i,
      parentId: info.uniqueChar,
      parentName: info.eventName,
      data: isCohort ? data.map(([key, v]) => [toCohortFormat(key, info.timezone), v]) : data,
      dataSum,
    });
  }

  return {
    name: info.eventName,
    id: info.uniqueChar,
    categories,
    typeGroupBy: info.typeGroupBy,
    series: groups,
    isSplitBy: !!info.splitBy,
  };
};

const toChartData = (events) => (events || []).map(convertEventData);

export default toChartData;
